import PropTypes from 'prop-types';
import React from 'react';

import { Col } from 'react-bootstrap';

class LeftSide extends React.Component {
    render() {
        return (
            <Col xs={3} sm={3} md={3} lg={3} className={this.props.addClass}>
                {this.props.children}
            </Col>
        );
    }
}

LeftSide.propTypes = {
    addClass: PropTypes.string,
};

LeftSide.defaultProps = {
    addClass: 'col-left',
};

export default LeftSide;
